import _slicedToArray from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/regenerator";
export var createRenderInputsOfAudioNode = function createRenderInputsOfAudioNode(getAudioNodeConnections, getAudioNodeRenderer, isPartOfACycle) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(audioNode, nativeOfflineAudioContext, nativeAudioNode, trace) {
      var audioNodeConnections, nextTrace;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              audioNodeConnections = getAudioNodeConnections(audioNode);
              nextTrace = [].concat(_toConsumableArray(trace), [audioNode]);
              _context2.next = 4;
              return Promise.all(audioNodeConnections.activeInputs.map(function (connections, input) {
                return Array.from(connections).filter(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 1),
                      source = _ref3[0];

                  return !nextTrace.includes(source);
                }).map( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
                    var _ref6, source, output, audioNodeRenderer, renderedNativeAudioNode, destination;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _ref6 = _slicedToArray(_ref4, 2), source = _ref6[0], output = _ref6[1];
                            audioNodeRenderer = getAudioNodeRenderer(source);
                            _context.next = 4;
                            return audioNodeRenderer.render(source, nativeOfflineAudioContext, nextTrace);

                          case 4:
                            renderedNativeAudioNode = _context.sent;
                            destination = audioNode.context.destination;

                            if (!isPartOfACycle(source) && (audioNode !== destination || !isPartOfACycle(audioNode))) {
                              renderedNativeAudioNode.connect(nativeAudioNode, output, input);
                            }

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x5) {
                    return _ref5.apply(this, arguments);
                  };
                }());
              }).reduce(function (allRenderingPromises, renderingPromises) {
                return [].concat(_toConsumableArray(allRenderingPromises), _toConsumableArray(renderingPromises));
              }, []));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
};